<template>
    <div class="change-mobile-page">
        <mt-header fixed title="更换手机号" style="background:#ffffff;color:#262626;">
            <router-link to="/my" slot="left">
                <mt-button icon="back"></mt-button>
            </router-link>
        </mt-header>

        <div class="confirm-num" v-if="!isNext">
            <ul class="old-num form">
                <li class="title">验证原手机号</li>
                <li class="input-wrap" @click="show('old')">
                    <span class="area">{{old_phone_region}}</span><span class="code">+{{old_country_code}}<img src="../assets/images/global_more_arrow@3x.png"></span>
                </li>
                <li class="input-wrap">
                    <input type="text" placeholder="请输入手机号" v-model="old_phone">
                </li>
            </ul>

            <ul class="new-num form">
                <li class="title">填写新手机号</li>
                <li class="input-wrap" @click="show('new')">
                    <span class="area">{{new_phone_region}}</span><span class="code">+{{new_country_code}}<img src="../assets/images/global_more_arrow@3x.png"></span>
                </li>
                <li class="input-wrap">
                    <input type="text" placeholder="请输入手机号" v-model="new_phone">
                </li>
            </ul>

            <div v-if="canNext" class="nextstep" @click="goNext">
                下一步
            </div>
            <div v-if="!canNext" class="nextstep disabled">
                下一步
            </div>
        </div>
        
        <div class="getCode" v-if="isNext">
            <p><span v-show="isShowTip">已向手机号+{{old_country_code}} {{old_phone}}发送验证码</span></p>
            <div class="inputWrapper">
                <input type="text" placeholder="请输入验证码" v-model="password">
                <span v-show="sms_show" @click="getSms">获取验证码</span>
                <span v-show="!sms_show">{{count}}秒后重发</span>
            </div>
            <div class="confirm-btn" @click="changePhone" v-if="!canChange">
                确认更换
            </div>
            <div class="confirm-btn disabled" v-if="canChange">
                确认更换
            </div>
        </div>

        <AwesomePicker  ref="pickers" :data="picker.slot" :textConfirm="picker.textConfirm"  :colorConfirm="picker.colorConfirm" :colorCancel="picker.colorCancel" @confirm="handlePickerConfirm"></AwesomePicker >
    </div>
</template>

<script>

import AwesomePicker  from '../assets/lib/awesome-picker'

export default {

    data(){
        return{
            picker:{
                slot:[],
                textConfirm:"完成",
                colorConfirm:"#3189FF",
                colorCancel:"#3189FF"
            },
            old_phone:'',
            new_phone:'',
            sms_show:true,
            canNext:false,
            isNext:false,
            old_country_code:'86',
            new_country_code:'86',
            old_phone_region: '中国大陆',
            new_phone_region: '中国大陆',
            pickType: '',
            country_arr: [],
            isShowTip: false,
            count: '59',
            password: '',
            canChange: false
        }
    },
    watch:{

    },
    methods:{
        goNext(){
            this.getSms()
            this.isNext = true
        },
        show(type) {
            this.pickType = type
            this.$refs.pickers.show();
        },
        handlePickerConfirm(item){
            let index = item[0].index
            if(this.pickType == 'old'){
                this.old_phone_region = this.country_arr[index].country
                this.old_country_code = this.country_arr[index].code
            }else {
                this.new_phone_region = this.country_arr[index].country
                this.new_country_code = this.country_arr[index].code
            }
        },
        countDown(){
            let vm = this;
            let interval = setInterval(function(){
                vm.count = vm.count -1;
                if(vm.count == 0){
                    vm.sms_show = true;
                    window.clearInterval(interval);  
                }
            },1000)
        },
        getSms(){
            var vm = this;
            this.count = 59;
            
            let info = {
               'phone':vm.new_phone,
               'country_code':vm.new_country_code,
               'type':3,
               'app_id':window.config.appid,
              
            }
            this.$store.dispatch("getSms",info).then((res)=>{
                var result = res.data;
                if(result.code == 0){
                     vm.countDown();
                     vm.sms_show = false;
                }
            })
        },
        getCountryCodes(){
            var vm = this;
            this.$store.dispatch("getCountryCodes").then((res)=>{
                var result = res.data;
                if(result.code == 0){
                    let countryCodes = result.res;
                    vm.country_arr = countryCodes;
                    let arr1 = [];
                    for(let i=0;i<countryCodes.length;i++){
                        let code = `<span class="country_code">+${countryCodes[i].code}</span><span class="country_name">${countryCodes[i].country}</span>`;
                        arr1.push(code)
                    }
                    vm.picker.slot.push(arr1)
                   
                }
            })
        },
        validCode(){
            let reg_code = /^\d{6,}$/;
            if(this.code && reg_code.test(this.code)){
                this.canChange = true;
            }else{
                this.canChange = false;
            }

        },
        validPhone(){
            this.old_phone = this.old_phone.replace(/\s+/g, "");
            this.new_phone = this.new_phone.replace(/\s+/g, "");
            var old_reg_phone
            if(this.old_country_code != 86){
                old_reg_phone = /^\d{6,}$/;
            }else{
                old_reg_phone = /^1\d{10}$/;
            }

            var new_reg_phone
            if(this.new_country_code != 86){
                new_reg_phone = /^\d{6,}$/;
            }else{
                new_reg_phone = /^1\d{10}$/;
            }
            
            if(this.old_phone && this.new_phone && old_reg_phone.test(this.old_phone) && new_reg_phone.test(this.new_phone)){
                this.canNext = true;
            }else{
                this.canNext = false;
            }
        },
        changePhone(){
            
            var vm = this;
            if(!vm.password.replace(/\s+/g, "")){
                this.$toastlj("请输入验证码")
                return
            }
            let access_token = localStorage.access_token
            let info = {
                old_phone:vm.old_phone.replace(/\s+/g, ""),
                phone:vm.new_phone.replace(/\s+/g, ""),
                country_code:vm.old_country_code.replace(/\s+/g, ""),
                code:vm.password.replace(/\s+/g, ""),
                access_token: access_token
            };
            this.$store.dispatch("bindPhone",info).then((res)=>{
                var result = res.data;
                if(result.code == 0){
                    vm.$router.push({name:"my",query:{phone:this.new_phone}})
                }else if(result.code == 1300){
                    vm.$toastlj('验证码错误')

                }else{
                    vm.$toastlj(result.message)
                    
                }
            })
        }
    },
    components:{
        AwesomePicker
    },
    mounted(){
        
    },
    watch: {
        old_phone: function(value) {
            this.validPhone()
        },
        new_phone: function (value) {
            this.validPhone()
        },
        password: function (){

        }
    },
    created(){
        this.getCountryCodes()
    }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/ChangeMobile.vue